var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "update-teamgram-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("billing.companyName")))]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { name: "apiKey" },
                model: {
                  value: _vm.clone.payload.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "company", $$v)
                  },
                  expression: "clone.payload.company",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("API Key")]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { name: "apiKey" },
                model: {
                  value: _vm.clone.payload.apiKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "apiKey", $$v)
                  },
                  expression: "clone.payload.apiKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Pipeline")]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.clone.payload.customStageId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "customStageId", $$v)
                    },
                    expression: "clone.payload.customStageId",
                  },
                },
                _vm._l(_vm.pipelines, function (pipeline) {
                  return _c(
                    "a-select-option",
                    { key: pipeline.id, attrs: { value: pipeline.Id } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(pipeline.Name) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("wp.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }